// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a085443d","239":"11ab217b","453":"162b7a94","455":"05661a85"}[chunkId] + ".chunk.js";
};